import React, { useState } from "react";
import { useTenant } from "../../../../Context/Tenant/TenantContext";
import { DELETE_TENANT_APP, SET_NOTIFICATION_MESSAGE, SET_NOTIFICATION_TYPE, SET_SELECTED_MASTER_PROJECT_ID, SET_SELECTED_TENANT_ID, TOGGLE_SHOW_DELETE_TENANT_APP_DIALOG, TOGGLE_SHOW_NOTIFICATION, UPDATE_TENANT_APP } from "../TenantEvents";
import RemoveDialog from "../../../Shared/Remove/RemoveDialog";
import { deleteTenantProject } from "../../../../API/Tenant/Tenant";
import { useTranslation } from "react-i18next";

const DeleteTenantAppDialog = () => {
    const { state, dispatch } = useTenant();
    const [inProgress, setInProgress] = useState(false);
    const { selectedTenantId, tenants, projects } = state;
    const selectedTenant = tenants.find(tenant => tenant._id === selectedTenantId);
    const selectedProject = selectedTenant.masterProjects.find(project => project.masterProjectId === state.selectedMasterProjectId) || {};
    const project = projects.find(project => project._id === selectedProject.masterProjectId);

    const { t } = useTranslation([
        "tenant/tenant",
    ], {
        useSuspense: false
    })

    const handleClose = () => {
        dispatch({ type: SET_SELECTED_TENANT_ID, payload: null });
        dispatch({ type: SET_SELECTED_MASTER_PROJECT_ID, payload: null });
        dispatch({ type: TOGGLE_SHOW_DELETE_TENANT_APP_DIALOG });
    }

    const handleDeleteTenantApp = async () => {
        setInProgress(true);
        try {
            const response = await deleteTenantProject(selectedTenant._id, selectedProject.masterProjectId);
            if (response._id) {
                dispatch({
                    type: DELETE_TENANT_APP,
                    payload: {
                        id: selectedTenant._id,
                        masterProjectId: selectedProject.masterProjectId
                    }
                });
            } else {
                if (response.message) {
                    dispatch({ type: SET_NOTIFICATION_MESSAGE, payload: response.message });
                    dispatch({ type: TOGGLE_SHOW_NOTIFICATION });
                    dispatch({ type: SET_NOTIFICATION_TYPE, payload: "error" });
                }
                if (response.projectStatus) {
                    if (response.projectStatus === "deleted") {
                        dispatch({
                            type: DELETE_TENANT_APP,
                            payload: {
                                id: selectedTenant._id,
                                masterProjectId: selectedProject.masterProjectId
                            }
                        });
                    } else {
                        dispatch({
                            type: UPDATE_TENANT_APP,
                            payload: {
                                id: selectedTenant._id,
                                masterProjectId: selectedProject.masterProjectId,
                                data: { status: response.projectStatus }
                            }
                        });
                    }
                }
                throw new Error("Failed to delete tenant");
            }
        } catch (error) {
            console.error(error);
        } finally {
            setInProgress(false);
            handleClose();
        }
    }

    if (!selectedTenant || !project) return null;

    return (
        <RemoveDialog
            showLoader={inProgress}
            Title={t("delete_tenant_app_invitation")}
            toggleDeleteDialog={handleClose}
            message={t("delete_tenant_app_invitation_message")}
            message2={t("delete_tenant_app_invitation_message2", { appName: project.name, tenantName: selectedTenant.name })}
            message3={t("delete_tenant_app_invitation_message3")}
            onDelete={handleDeleteTenantApp}
            onCancel={handleClose}
            deleteButtonText={t("delete_button")}
            cancelButtonText={t("cancel_button")}
        />
    )
}

export default DeleteTenantAppDialog;